export default __webpack_public_path__ + "static/media/PGL_Icon.c758bf6a.png";